import React, { useState } from 'react';
import Modal from 'react-modal';
import BlockContextMenu from '../../../common/BlockContextMenu/BlockContextMenu';
import ProtectedImage from '../../../common/ProtectedImage/ProtectedImage';
import ThumbnailSlider from '../../../common/ThumbnailSlider/ThumbnailSlider';
import {
  modalStyles,
  SlideLabel,
  ThumbnailImage,
  ThumbnailItem,
  ThumbnailLabel,
  ThumbnailsGrid,
  CloseButton,
  ContentWrapper,
  LargeImageContainer,
} from './DTImageGridGallery.styles';
import { NO_IMAGE_PLACEHOLDER } from '../../../../constants/images';

const DTImageGridGallery = ({ imageObjects = [] }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const openModal = (index) => {
    setSelectedIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <ThumbnailsGrid>
        {imageObjects.map((imageObj, index) => (
          <ThumbnailItem key={imageObj.fileName + index}>
            <ThumbnailImage
              key={imageObj.fileName}
              imgSrc={imageObj.src ?? NO_IMAGE_PLACEHOLDER}
              altText={imageObj.fileName}
              className={'zoom-in'}
              isSelected={false}
              onThumbClick={() => openModal(index)}
            />
            <ThumbnailLabel>{imageObj.fileName}</ThumbnailLabel>
          </ThumbnailItem>
        ))}
      </ThumbnailsGrid>
      <Modal
        contentLabel={'dialog'}
        style={modalStyles}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        appElement={document.getElementById('root')}
        ariaHideApp={false}
      >
        <CloseButton onClick={() => closeModal()}>&times;</CloseButton>
        <ContentWrapper>
          {imageObjects[selectedIndex] && <SlideLabel>{imageObjects[selectedIndex].fileName}</SlideLabel>}
          <BlockContextMenu>
            <LargeImageContainer>
              {imageObjects[selectedIndex] && (
                <ProtectedImage
                  src={imageObjects[selectedIndex].src ?? NO_IMAGE_PLACEHOLDER}
                  altText={imageObjects[selectedIndex].fileName}
                />
              )}
            </LargeImageContainer>
          </BlockContextMenu>
          <ThumbnailSlider
            imageObjects={imageObjects}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            maxSlidesOnLine={4}
          />
        </ContentWrapper>
      </Modal>
    </>
  );
};

export default DTImageGridGallery;
